import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { luxColors, Iffy } from '@alucio/lux-ui';
import { LocalVideoPreview, useRoomState, MainParticipant as CurrentUserParticipant, LocalAudioLevelIndicator, useVideoContext, } from '../main';
import { useMeetingControls } from '../../../../../src/packages/video/src/hooks/useMeetingControls/useMeetingControl';
const styles = StyleSheet.create({
    audioLevelContainer: {
        paddingRight: 5,
        paddingLeft: 4,
    },
    controls: {
        backgroundColor: luxColors.opacityBackground.darker,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingRight: 6,
        paddingBottom: 3,
        paddingTop: 3,
        marginBottom: -1,
        width: 'auto',
        alignSelf: 'flex-start',
    },
    controlsContainer: {
        alignItems: 'flex-end',
        display: 'flex',
        flexDirection: 'column-reverse',
        height: '100%',
        justifyContent: 'space-between',
        position: 'absolute',
        width: '100%',
    },
    participant: {
        width: 216,
        height: 120,
    },
    participantNameContainer: {
        flexGrow: 5,
        flexDirection: 'column',
        alignSelf: 'center',
        overflow: 'hidden',
        maxWidth: 183,
        paddingLeft: 6,
    },
    participantName: {
        color: luxColors.info.primary,
        fontSize: 12,
        fontWeight: '500',
        lineHeight: 20,
    },
});
function ParticipantName() {
    var _a;
    const { room: { localParticipant } } = useVideoContext();
    // All Video Participant IDs are in the form <attendeeId>.<participantType>.<Name>
    const name = (_a = localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.identity) === null || _a === void 0 ? void 0 : _a.split('.').slice(2).join('.');
    return (React.createElement(Text, { style: styles.participantName, numberOfLines: 1 }, name));
}
function Presenter(props) {
    var _a;
    const roomState = useRoomState();
    const { videoSize } = useMeetingControls();
    return (React.createElement(View, { style: [
            styles.participant,
            props.styles,
            { width: videoSize.container.width, height: videoSize.container.height },
        ] },
        roomState === 'disconnected'
            ? React.createElement(LocalVideoPreview, { placeholderIconStyle: props.placeHolderIconStyle })
            : React.createElement(CurrentUserParticipant, null),
        React.createElement(Iffy, { is: props.hideParticipantName === false },
            React.createElement(View, { style: styles.controlsContainer },
                React.createElement(View, { style: styles.controls },
                    React.createElement(View, { style: styles.audioLevelContainer },
                        React.createElement(LocalAudioLevelIndicator, null)),
                    React.createElement(View, { style: [styles.participantNameContainer, { width: (_a = videoSize.nameContainer) === null || _a === void 0 ? void 0 : _a.width }] }, roomState !== 'disconnected'
                        ? React.createElement(ParticipantName, null)
                        : React.createElement(Text, { numberOfLines: 1, style: styles.participantName }, "Connecting.....")))))));
}
Presenter.defaultProps = {
    hideParticipantName: false,
};
export default Presenter;
//# sourceMappingURL=Presenter.js.map